<template>
  <div>
    <b-overlay :show="showOverlay" spinner-variant="primary">
      <ValidationObserver ref="searchForm" slim>
        <b-form @submit.prevent="submit" class="filters-form">
          <!-- Search form component - can be split into sub-components (such as Room) -->
          <b-col md="12">
            <h5 class="search-title">{{formTitle}}</h5>
            <b-form-row>
              <b-col md="3">
                <ValidationProvider
                  name="Moneda"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Moneda*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="currency"
                  >
                    <b-form-select
                      id="currency"
                      size="sm"
                      v-model="selectedCurrency"
                      :options="currencyOptions"
                      :state="getValidationState(vContext)"
                      aria-describedby="currency"
                      ></b-form-select>
                      <b-form-invalid-feedback id="currency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Tara Destinatie"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Tara Destinatie*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="country"
                  >
                    <b-form-select
                      id="country"
                      size="sm"
                      v-model="selectedCountry"
                      :options="countryOptions"
                      :state="getValidationState(vContext)"
                      aria-describedby="country"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="country">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Oras / statiune"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    label="Oras / statiune*"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="resort"
                  >
                    <b-form-select
                      id="resort"
                      size="sm"
                      v-model="selectedResort"
                      :options="resortOptions"
                      :disabled="!selectedCountry"
                      :state="getValidationState(vContext)"
                      aria-describedby="resort"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Zona / statiune"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="area"
                >
                  <b-form-select
                    id="area"
                    size="sm"
                    v-model="selectedArea"
                    :options="areaOptions"
                    :disabled="!selectedResort"
                    aria-describedby="area"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- oricare --</b-form-select-option>
                      </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3">
                <ValidationProvider
                  name="Check in"
                  :rules="{ required: true }"
                  vid="checkIn"
                  v-slot="vContext"
                  >
                  <b-form-group
                    label="Check in"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="checkIn">
                    <DatePicker
                      v-model="selectedCheckIn"
                      id="checkIn"
                      :state="getValidationState(vContext)"
                      size="sm"
                      placeholder="zz/ll/aaaa"
                      aria-describedby="checkin-live-feedback"
                      @change="onCheckInChange"
                    ></DatePicker>
                    <b-form-invalid-feedback id="checkin-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="1">
                <ValidationProvider
                  name="Nopti"
                  :rules="{ required: true }"
                  vid="nights"
                  v-slot="vContext">
                  <b-form-group
                    label="Nopti"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="checkIn">
                    <b-input
                      v-model="nights"
                      size="sm"
                      aria-describedby="nights-live-feedback" />
                    <b-form-invalid-feedback id="nights-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Check out"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="checkOut"
                  :rules="{ required: true }"
                  vid="checkOut"
                  v-slot="vContext"
                  >
                  <b-form-group
                    label="Check out"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="checkOut"
                    >
                    <DatePicker
                      v-model="selectedCheckOut"
                      id="checkOut"
                      :state="getValidationState(vContext)"
                      size="sm"
                      placeholder="zz/ll/aaaa"
                      aria-describedby="checkout-live-feedback"
                      @change="onCheckOutChange"
                    ></DatePicker>
                    <b-form-invalid-feedback id="checkout-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Categorie hotel"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="category"
                >
                  <b-form-select
                    id="category"
                    size="sm"
                    v-model="selectedCategory"
                    :options="categoryOptions"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- oricare --</b-form-select-option>
                      </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Hotel"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="hotel"
                >
                  <b-form-select
                    id="hotel"
                    size="sm"
                    v-model="selectedHotel"
                    :options="hotelOptions"
                    :disabled="!selectedResort"
                    aria-describedby="hotel"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- oricare --</b-form-select-option>
                      </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3" v-for="(room, i) in selectedParams.rooms" :key="genRoomKey(i)">
                <b-form-group
                  :label="'Camera ' + (i + 1)"
                  label-class="font-weight-bold my-0 py-0 form-label"
                >
                  <room
                    v-model="selectedParams.rooms[i]"
                    :id="i"
                    :showDelete="i && (selectedParams.rooms.length > 1)"
                    :showAdd = "!i && (selectedParams.rooms.length < 3)"
                    @add = "onRoomAdd"
                    @delete = "onRoomDelete(i)">
                  </room>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <!-- <b-col md="3">
                <label class="font-weight-bold my-0 py-0 form-label"></label>
                <b-button block size="sm" class="btn-custom-blue" @click="$emit('openFees')">Taxa de servicu Proprie</b-button>
              </b-col> -->
              <b-col md="9">
                <!-- <p class="text-danger mt-3 text-center">
                  <b></b>
                </p> -->
                <div class="d-flex align-items-center  mt-3">
                  <b-icon icon="exclamation-triangle-fill" font-scale="2" class=" mr-2 text-danger"></b-icon>
                  <small class="text-danger font-weight-bold">
                    ATENTIE: <span class="text-uppercase">Tarifele de individual sunt nete, nu se cedeaza comision!</span><br/>
                    VA RUGAM SA CITITI CU ATENTIE CONDITIILE DE ANULARE/ PENALIZARE MENTIONATE IN DREPTUL FIECAREI OFERTE. PENTRU REZERVARILE NON REFUNDABLE, PENALIZAREA IN CAZUL ANULARII ESTE DE 100%
                  </small>
                </div>
              </b-col>
              <b-col md="3" class="d-flex align-items-center justify-content-end">
                <b-button size="sm" variant="outline-info mr-2" @click.prevent="$emit('openFees')">Markup</b-button>
                <b-button variant="outline-primary" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2">Cauta</span></b-button>
              </b-col>
            </b-form-row>
          </b-col>
        </b-form>
      </ValidationObserver>
    </b-overlay>
   </div>
</template>

<script>
import moment from 'moment'
import formMixin from '@/app/private/shared/mixins/search_forms'
import room from '@/app/private/shared/components/search_form_room'
import DatePicker from 'b2b-common/components/datepicker'
import { currencies } from '@/shared/utils'
import { hotelRatings } from 'b2b-common/utils/hotel'
import { getCountries, getResorts, getAreas, getHotels } from 'b2b-common/services/api/hotel'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'searchForm',
  components: { DatePicker, room },
  mixins: [formMixin, validation, toast],
  props: ['params'],
  data () {
    return {
      selectedParams: {
        distribution: null,
        currency: null,
        country: null,
        resort: null,
        area: null,
        hotel: null,
        category: null,
        checkIn: null,
        checkOut: null
      },
      countriesList: [],
      resortsList: [],
      areasList: [],
      hotelsList: [],
      defaultNights: 7
    }
  },
  methods: {
    async submit () {
      const success = await this.$refs.searchForm.validate()
      if (!success) {
        this.addToast({ title: 'Formular invalid', message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
      } else {
        this.onSubmit()
      }
    },
    updateCheckIn (date) {
      this.selectedCheckIn = date
    },
    updateCheckOut (date) {
      this.selectedCheckOut = date
    },
    getCountriesList () {
      this.resetList('countries')
      const promise = getCountries({
        currency: this.selectedCurrency,
        dc: this.params.distribution
      })
      this.addRequest('countries')
      promise
        .then(res => {
          this.countriesList = res
          if (this.selectedCountry && !this.valueExistsInList('countries', this.selectedCountry)) {
            this.resetList(['resorts', 'areas', 'hotels'])
            this.selectedCountry = null
          }
          return this.countriesList
        })
        .finally(() => { this.removeRequest('countries') })
      return promise
    },
    getResortsList () {
      let promise
      this.resetList('resorts')
      if (!this.selectedCountry) promise = Promise.resolve([])
      else {
        promise = getResorts({
          currency: this.selectedCurrency,
          country: this.selectedCountry,
          dc: this.params.distribution
        })
      }
      this.addRequest('resorts')
      promise
        .then(res => {
          this.resortsList = res
          if (this.selectedResort && !this.valueExistsInList('resorts', this.selectedResort)) {
            this.resetList(['areas', 'hotels'])
            this.selectedResort = null
          }
          return this.resortsList
        })
        .finally(() => { this.removeRequest('resorts') })
      return promise
    },
    getAreasList () {
      let promise
      this.resetList('areas')
      if (!this.selectedResort) promise = Promise.resolve([])
      else {
        promise = getAreas({
          currency: this.selectedCurrency,
          resort: this.selectedResort,
          dc: this.params.distribution
        })
      }
      this.addRequest('areas')
      promise
        .then(res => {
          this.areasList = res
          if (this.selectedArea && !this.valueExistsInList('areas', this.selectedArea)) {
            this.resetList('hotels')
            this.selectedArea = null
          }
          return this.areasList
        })
        .finally(() => { this.removeRequest('areas') })
      return promise
    },
    getHotelsList () {
      let promise
      this.resetList('hotels')
      if (!this.selectedResort && !this.selectedArea) promise = Promise.resolve([])
      else {
        promise = getHotels({
          currency: this.selectedCurrency,
          destination: this.selectedArea ? this.selectedArea : this.selectedResort,
          dc: this.params.distribution
        })
      }
      this.addRequest('hotels')
      promise
        .then(res => {
          this.hotelsList = res
          if (this.selectedHotel && !this.valueExistsInList('hotels', this.selectedHotel)) {
            this.selectedHotel = null
          }
          return this.hotelsList
        })
        .finally(() => { this.removeRequest('hotels') })
      return promise
    },
    onCheckOutChange (val) {
      const mVal = moment(val)
      // check to see if it is a valid value
      // it it's invalid don't do anything
      if (!mVal.isValid()) return
      let mCheckIn = moment(this.selectedCheckIn)
      if (!mCheckIn.isValid() || mCheckIn.isAfter(mVal)) {
        // modify check in according to no of nights
        if (!mCheckIn.isValid()) mCheckIn = moment(mVal).hour(15).minute(0).second(0)
        const currentNights = moment(mCheckIn).startOf('day').diff(moment(mVal).startOf('day'), 'days')
        this.selectedCheckIn = mCheckIn.subtract(currentNights + this.defaultNights, 'days').toDate()
      }
    },
    onCheckInChange (val) {
      const mVal = moment(val)
      // check to see if it is a valid value
      // it it's invalid don't do anything
      if (!mVal.isValid()) return
      let mCheckOut = moment(this.selectedCheckOut)
      // modify check out according to default no of nights
      if (!mCheckOut.isValid()) mCheckOut = moment(mVal).hour(11).minute(0).second(0)
      const currentNights = moment(mVal).startOf('day').diff(moment(mCheckOut).startOf('day'), 'days')
      this.selectedCheckOut = mCheckOut.add(currentNights + this.defaultNights, 'days').toDate()
    }
  },
  computed: {
    formTitle () {
      switch (this.$route.path) {
        case '/private/villas/search':
          return 'Vile Extern'
        default:
          return 'Hotel Extern'
      }
    },
    selectedCheckIn: {
      get () {
        return moment(this.selectedParams.checkIn, 'DD-MM-YYYY').toDate()
      },
      set (val) {
        this.selectedParams.checkIn = moment(val).format('DD-MM-YYYY')
      }
    },
    selectedCheckOut: {
      get () {
        return moment(this.selectedParams.checkOut, 'DD-MM-YYYY').toDate()
      },
      set (val) {
        this.selectedParams.checkOut = moment(val).format('DD-MM-YYYY')
      }
    },
    selectedCurrency: {
      get () { return this.selectedParams.currency },
      async set (val) {
        this.selectedParams.currency = val
        await this.getCountriesList()
        this.getResortsList()
        this.getAreasList()
        this.getHotelsList()
      }
    },
    currencyOptions () {
      return currencies.map(el => ({ value: el.code, text: el.code }))
    },
    selectedCountry: {
      get () {
        return this.selectedParams.country || null
      },
      async set (val) {
        this.selectedParams.country = val
        await this.getResortsList()
        this.getAreasList()
        this.getHotelsList()
      }
    },
    countryOptions () {
      return this.countriesList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedResort: {
      get () { return this.selectedParams.resort || null },
      async set (val) {
        this.selectedParams.resort = val
        await this.getAreasList()
        this.getHotelsList()
      }
    },
    resortOptions () {
      return this.resortsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedArea: {
      get () { return this.selectedParams.area },
      set (val) {
        this.selectedParams.area = val
        this.getHotelsList()
      }
    },
    areaOptions () {
      return this.areasList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedHotel: {
      get () { return (Array.isArray(this.selectedParams.hotels) && this.selectedParams.hotels.length) ? this.selectedParams.hotels[0] : null },
      set (val) { this.selectedParams.hotels = val ? [val] : null }
    },
    hotelOptions () {
      return this.hotelsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedCategory: {
      get () { return this.selectedParams.category },
      set (val) { this.selectedParams.category = val }
    },
    categoryOptions () {
      return hotelRatings.map(el => ({ value: el, text: el + ' stele' }))
    },
    showOverlay () { return this.activeRequests.length > 0 },
    nights: {
      get () {
        if (this.selectedParams.checkIn && this.selectedParams.checkOut) {
          return moment(this.selectedCheckOut).startOf('day').diff(moment(this.selectedCheckIn).startOf('day'), 'days')
        }
        return this.defaultNights
      },
      set (val) {
        if (val === null || val === undefined || val === '' || val < 0) return
        this.defaultNights = val
        if (this.selectedCheckIn) {
          const start = moment(this.selectedCheckIn)
          const end = (this.selectedCheckOut) ? moment(this.selectedCheckOut) : moment(start).set('hour', 11).set('minute', 0)
          const eodStart = moment(start).startOf('day')
          const eodEnd = moment(end).startOf('day')
          const currentNights = eodEnd.diff(eodStart, 'days')
          this.selectedCheckOut = end.add(val - currentNights, 'days').toDate()
        }
      }
    }
  },
  created () {
    this.selectedParams = { ...this.params }
    this.getCountriesList()
    this.getResortsList()
    this.getAreasList()
    this.getHotelsList()
  }
}
</script>

<style>
  .datepicker__wrapper.datePiker {
    height: 30px!important;
  }
  .datepicker__wrapper.datePiker > .datepicker__dummy-wrapper{
    border-color: #ccc;
    border-radius: 4px;
  }
  .datepicker__wrapper.datePiker > .datepicker__dummy-wrapper .datepicker__input {
    height: 31px!important;
    line-height: 2.1!important;
  }
  .datePiker .datepicker__clear-button {
    margin: -1px -2px 0 0;
  }
</style>
